import { useMutation, useQuery } from '@tanstack/react-query';

import { getUserRoles, updateUser } from '../../../../../api';
import { AggregateUser } from '../../../../../types/aggregateUser';

export const useUpdateUser = () =>
  useMutation({ mutationKey: ['updateUser'], mutationFn: (data: Partial<AggregateUser>) => updateUser(data) });

export const useUserRoles = () => useQuery({ queryKey: ['getUserRoles'], queryFn: getUserRoles });
